import React, { ReactNode } from "react";

/**
 * Responsive grid layout for `PromoCard` components
 */
export default function PromoCardGrid({ children }: { children: ReactNode }) {
  return (
    <ul className="max-w-container mx-auto flex flex-wrap justify-center px-6">
      {children}
    </ul>
  );
}
